<template>
  <div class="main-container">
    <div class="main-header">
      <div>
        <h4>IMPORT/EXPORT</h4>
        <span></span>
      </div>
    </div>
    <div class="content-container">
      <ImportItemBox
        @onButtonClick="onButtonClick"
        :headerTitle="'Import'"
        :iconPath="'static/icons/upload-ico.svg'"
        :buttonList="[
          {
            text: $t('import_contacts_as_csv'),
            value: 'import_contacts_as_csv',
          },
          {
            text: $t('import_contacts_as_vcard'),
            value: 'import_contacts_as_vcard',
          },
          {
            text: $t('download_contacts_csv_sample'),
            value: 'download_contacts_csv_sample',
          },
        ]"
      />
      <ImportItemBox
        @onButtonClick="onButtonClick"
        :headerTitle="'Export'"
        :iconPath="'static/icons/download-ico.svg'"
        :buttonList="[
          {
            value: 'export_excel',
            text: $t('export_excel'),
          },
        ]"
      />
      <ImportItemBox
        @onButtonClick="onButtonClick"
        :headerTitle="'Merge'"
        :iconPath="'static/icons/merge-ico.svg'"
        :buttonList="[
          {
            value: 'merge_contact',
            text: $t('merge_contact'),
          },
        ]"
      />
    </div>
    <v-dialog v-model="isImportCSVModal" persistent width="562">
      <ImportCSV
        @cancelled="isImportCSVModal = false"
        @done="onImportCSVContactsDone"
      />
    </v-dialog>
    <v-dialog v-model="isImportVcardModal" persistent width="562">
      <ImportVcard
        @cancelled="isImportVcardModal = false"
        @done="onImportVcardContactsDone"
      />
    </v-dialog>
    <ModalContainer :modalKey="'isCompareModal'" :width="'medium'">
      <CompareModal
        @cancelled="onMergeContactsCancelled()"
       
      />
    </ModalContainer>
  </div>
</template>

<script>
//import { SelectTree, createNode } from "../../../../plugins/select-tree";
import { createGridHost } from "@/dt-plugins/sidewindow/grid-host.mixin";
import { contactImportExportGrid } from "./import-export/sw-grid";

import { createModalMixin } from '@/dt-plugins/modal/modal.mixin';

import FileDownload from "js-file-download";
import { ContactIMEXService } from "../services/contact_import_export.service";
import CompareModal from './import-export/merge-contact-compare-modal';
import ModalContainer from "@dtplugins/modal/modal-container";
import ImportItemBox from "./import-export/item-box";
import ImportCSV from "./import-export/import-csv";
import ImportVcard from "./import-export/import-vcard";

export default {
  components: {
    ModalContainer,
    ImportItemBox,
    ImportCSV,
    ImportVcard,
    CompareModal
  },
  props: [],
  data() {
    return {
      isImportCSVModal: false,
      importCSVContactsDoneMessage: "",
      isImportVcardModal: false,
      importVcardContactsDoneMessage: "",
    };
  },
  watch: {},
  computed: {},
  created() {},
  mixins: [
     createModalMixin('isCompareModal'),
  ],
  mounted: function () {},
  methods: {
    onButtonClick: function (value) {
      switch (value) {
        case "import_contacts_as_csv":
          this.isImportCSVModal = true;
          break;
        case "import_contacts_as_vcard":
          this.isImportVcardModal = true;
          break;
        case "download_contacts_csv_sample":
          this.onClickDownloadSampleCSV();
          break;
        case "export_excel":
          this.onClickExportExcel();
          break;
        case "merge_contact":
          this.onMergeContactsClicked();
          break;
      }
    },
    onClickDownloadSampleCSV() {
      window.open(
        "https://detailss3web.s3.amazonaws.com/files/common_for_all/details contacts Import Sheet.csv",
        ""
      );
    },
    onMergeContactsClicked: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "contacts_import_export_merge_contacts",
        },
      });
    },
    onClickExportExcel() {
      ContactIMEXService.getExportContactsExcel().then((res) => {
        FileDownload(res.data, "contacts.xlsx");
      });
    },
    onImportCSVContactsDone(doneMessage) {
      if (doneMessage.hasOwnProperty("total_imported")) {
        doneMessage =
          "status: " + doneMessage.total_imported + " entries inserted";
      }

      this.importCSVContactsDoneMessage = doneMessage;
    },
    onImportVcardContactsDone(doneMessage) {
      this.importVcardContactsDoneMessage = doneMessage;
    },
    onMergeContactsCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: calc(100vh - 180px);
  padding: 0 10px;
  overflow: auto;
  .main-header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 50px;
    h4 {
      color: #282828;
      font-weight: 500;
      text-transform: uppercase;
      opacity: 1;
      font: normal normal bold 13px/18px Roboto;
    }
  }
  .content-container {
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    gap: 20px;
    max-width: 1100px;
    .item--box-style {
      flex: 1 0 33.33%;
      border-radius: 10px;
      max-width: 330px;
      min-width: 330px;
      min-height: 250px;
      border: 1px solid var(--bc-880);

      // &:not(:first-child) {
      //   margin-left: 20px;
      // }
    }
    @media (max-width: 1280px) {
      // flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-left: 0px;
      gap: 20px;

      .item--box-style {
        // flex: 1 0 calc(33.33% - 21px);
        gap: 20px;
        &:not(:first-child) {
          // margin-top:  20px;
          // margin-left: 20px;
        }
      }
    }
  //   @media (max-width: 1280px) {
  //     flex-direction: z;
      
  //     .item--box-style {
  //       &:not(:first-child) {
  //         margin-top: 20px;
  //         margin-left: 0px;
  //       }
  //     }
  //   }
  }
  .menu-container {
    margin-top: 0px !important;
  }
}
</style>